export default __webpack_public_path__ + "static/media/arrow-bar-down_darkGray3.0bee58ae.svg";